module.exports = __webpack_public_path__ + "img/model.0b553d3e.png";